import React, { createContext, useContext, useState, ReactNode, useEffect } from "react";

interface LayoutProviderProps {
    children: ReactNode;
    baseZIndex?: number;
}

type LayoutContextType = {
    baseZIndex: number;
    isOverlayVisible: boolean;
    showOverlay: (disableCloseOnClick?: boolean) => void;
    hideOverlay: () => void;
    hideOverlayOnClick: () => void;
};

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export const LayoutProvider: React.FC<LayoutProviderProps> = ({ baseZIndex = 0, children }) => {
    const [isOverlayVisible, setIsOverlayVisible] = useState(false);
    const [disableCloseOnClick, setDisableCloseOnClick] = useState(false);

    const showOverlay = (disableCloseOnClick?: boolean) => {
        setDisableCloseOnClick(disableCloseOnClick ?? false);
        setIsOverlayVisible(true);
    };
    const hideOverlay = () => setIsOverlayVisible(false);
    const hideOverlayOnClick = () => {
        if (!disableCloseOnClick) {
            setIsOverlayVisible(false);
        }
    };

    return (
        <LayoutContext.Provider value={{ baseZIndex, isOverlayVisible, showOverlay, hideOverlay, hideOverlayOnClick }}>
            {children}
        </LayoutContext.Provider>
    );
};

export const useLayout = (): LayoutContextType => {
    const context = useContext(LayoutContext);
    if (!context) {
        throw new Error("useLayout must be used within a LayoutProvider");
    }
    return context;
};
